import { render, staticRenderFns } from "./OdontogramClinicalChart.vue?vue&type=template&id=0c56ccc8&scoped=true"
import script from "./OdontogramClinicalChart.vue?vue&type=script&lang=js"
export * from "./OdontogramClinicalChart.vue?vue&type=script&lang=js"
import style0 from "./OdontogramClinicalChart.vue?vue&type=style&index=0&id=0c56ccc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56ccc8",
  null
  
)

export default component.exports